import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const sections = [
  {
    title: 'Sobre PetAdvisor',
    questions: [
      {
        q: '¿Qué es PetAdvisor España?',
        a: 'PetAdvisor España es una plataforma que ayuda a encontrar, comparar y recomendar veterinarias, tiendas, residencias, protectoras, adiestradores, parques y otros servicios relacionados con las mascotas.',
      },
      {
        q: '¿PetAdvisor presta directamente los servicios publicados?',
        a: 'No. PetAdvisor funciona como plataforma informativa y de contacto. Los servicios son prestados directamente por proveedores independientes, que son responsables de sus precios, disponibilidad, condiciones y calidad.',
      },
      {
        q: '¿En qué zonas funciona PetAdvisor?',
        a: 'PetAdvisor está orientado a proveedores y usuarios de España. Puedes buscar servicios por comunidad autónoma, municipio, categoría y otros filtros disponibles.',
      },
      {
        q: '¿Usar PetAdvisor tiene algún coste?',
        a: 'La búsqueda y consulta de perfiles puede realizarse gratuitamente. Algunos servicios adicionales, planes para proveedores o funcionalidades premium pueden tener un precio que se informará antes de contratarlos.',
      },
    ],
  },
  {
    title: 'Búsqueda y proveedores',
    questions: [
      {
        q: '¿Cómo encuentro un servicio para mi mascota?',
        a: 'Selecciona una categoría, una comunidad autónoma o un municipio y revisa los resultados. Puedes consultar información, fotografías, servicios, ubicación y reseñas de cada perfil.',
      },
      {
        q: '¿Cómo contacto con un proveedor?',
        a: 'Cuando el perfil tenga datos de contacto disponibles, podrás comunicarte directamente mediante teléfono, correo electrónico, sitio web, WhatsApp u otros canales publicados.',
      },
      {
        q: '¿PetAdvisor verifica a todos los proveedores?',
        a: 'PetAdvisor puede revisar información pública y aplicar controles internos, pero la aparición de un perfil no constituye una certificación, recomendación profesional ni garantía sobre los servicios ofrecidos.',
      },
      {
        q: '¿Qué debo revisar antes de contratar?',
        a: 'Comprueba precios, disponibilidad, condiciones, licencias cuando correspondan, políticas de cancelación, instalaciones y cualquier necesidad especial de tu mascota. Recomendamos confirmar todos los detalles directamente con el proveedor.',
      },
      {
        q: '¿Qué diferencia hay entre una residencia y una protectora?',
        a: 'Una residencia ofrece alojamiento o cuidado temporal para mascotas. Una protectora es una entidad u organización dedicada principalmente a la protección, rescate, acogida o adopción responsable de animales.',
      },
      {
        q: '¿Cómo informo de datos incorrectos en un perfil?',
        a: 'Puedes escribir a hola@petadvisor.es indicando el nombre del perfil, el dato que debe corregirse y, cuando sea posible, información que permita verificar el cambio.',
      },
    ],
  },
  {
    title: 'Reseñas y contenido',
    questions: [
      {
        q: '¿Quién puede publicar una reseña?',
        a: 'Los usuarios que hayan tenido una experiencia real con un proveedor pueden compartir su opinión respetando las normas de uso y evitando contenido falso, ofensivo, discriminatorio o ilegal.',
      },
      {
        q: '¿Los proveedores pueden eliminar reseñas negativas?',
        a: 'No pueden eliminarlas directamente. Pueden solicitar una revisión cuando consideren que una reseña incumple las normas, contiene datos personales, es falsa o vulnera derechos de terceros.',
      },
      {
        q: '¿PetAdvisor modifica las opiniones?',
        a: 'Podemos moderar, ocultar o retirar contenido que incumpla nuestras condiciones, pero no alteramos una opinión para cambiar su valoración o sentido.',
      },
      {
        q: '¿Puedo editar o eliminar mi reseña?',
        a: 'Cuando la plataforma lo permita, podrás gestionarla desde tu cuenta. También puedes solicitar ayuda escribiendo a hola@petadvisor.es desde el correo asociado a tu perfil.',
      },
      {
        q: '¿Cómo denuncio contenido inapropiado?',
        a: 'Comunícalo a hola@petadvisor.es indicando el perfil, reseña o contenido afectado y explicando brevemente el motivo de la denuncia.',
      },
    ],
  },
  {
    title: 'Cuentas y privacidad',
    questions: [
      {
        q: '¿Cómo creo una cuenta?',
        a: 'Puedes registrarte con los métodos habilitados en la plataforma y completar los datos solicitados. Debes proporcionar información verdadera y mantener tus credenciales seguras.',
      },
      {
        q: '¿Cómo reclamo o administro el perfil de mi negocio?',
        a: 'Regístrate como proveedor y utiliza la opción disponible para solicitar la gestión del perfil. PetAdvisor podrá pedir información adicional para verificar tu relación con el negocio.',
      },
      {
        q: '¿Cómo elimino mi cuenta?',
        a: 'Puedes solicitar la eliminación desde las opciones disponibles en tu cuenta o escribir a hola@petadvisor.es desde el correo registrado.',
      },
      {
        q: '¿Qué derechos tengo sobre mis datos personales?',
        a: 'Puedes solicitar acceso, rectificación, supresión, oposición, limitación del tratamiento y portabilidad, además de retirar tu consentimiento cuando esta sea la base utilizada.',
      },
      {
        q: '¿Cómo ejerzo mis derechos de protección de datos?',
        a: 'Escribe a hola@petadvisor.es indicando tu solicitud y la información necesaria para comprobar tu identidad. También puedes presentar una reclamación ante la Agencia Española de Protección de Datos.',
      },
      {
        q: '¿PetAdvisor utiliza cookies?',
        a: 'La plataforma puede utilizar cookies técnicas necesarias y, con tu consentimiento cuando corresponda, cookies de análisis o personalización. Encontrarás más información en la Política de Privacidad y en el aviso de cookies.',
      },
    ],
  },
  {
    title: 'Planes y pagos',
    questions: [
      {
        q: '¿Qué incluyen los planes para proveedores?',
        a: 'Las prestaciones, duración, precio y condiciones de cada plan se muestran antes de contratarlo. Pueden incluir mayor visibilidad, herramientas de contacto u otras funcionalidades.',
      },
      {
        q: '¿Los planes se renuevan automáticamente?',
        a: 'La modalidad de renovación debe mostrarse durante la contratación. Cuando exista renovación automática, se informará previamente y se ofrecerán medios para gestionar o cancelar el plan.',
      },
      {
        q: '¿Cómo solicito ayuda con un pago?',
        a: 'Escribe a hola@petadvisor.es indicando el correo de tu cuenta, la fecha aproximada y la referencia de la operación, sin enviar contraseñas ni datos completos de tarjetas.',
      },
    ],
  },
];

function FaqItem({ question, answer }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="border border-gray-200 rounded-xl bg-white overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between gap-4 p-5 text-left"
        aria-expanded={open}
      >
        <span className="font-semibold text-gray-900">{question}</span>
        <ChevronDown
          className={`w-5 h-5 flex-shrink-0 transition-transform ${
            open ? 'rotate-180' : ''
          }`}
        />
      </button>

      {open && (
        <div className="px-5 pb-5 text-gray-600 leading-7">
          {answer}
        </div>
      )}
    </div>
  );
}

export default function FAQ() {
  return (
    <div className="min-h-screen bg-gray-50 py-12" data-testid="faq-page">
      <div className="max-w-4xl mx-auto px-4">
        <div className="text-center mb-10">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
            Preguntas frecuentes
          </h1>
          <p className="mt-4 text-gray-600">
            Información sobre el funcionamiento de PetAdvisor España.
          </p>
        </div>

        <div className="space-y-10">
          {sections.map((section) => (
            <section key={section.title}>
              <h2 className="text-2xl font-bold text-gray-900 mb-5">
                {section.title}
              </h2>

              <div className="space-y-3">
                {section.questions.map((item) => (
                  <FaqItem
                    key={item.q}
                    question={item.q}
                    answer={item.a}
                  />
                ))}
              </div>
            </section>
          ))}
        </div>

        <div className="mt-12 p-6 bg-white border border-gray-200 rounded-xl text-center">
          <h2 className="text-xl font-bold text-gray-900">
            ¿Necesitas más ayuda?
          </h2>
          <p className="mt-2 text-gray-600">
            Escríbenos a{' '}
            <a
              href="mailto:hola@petadvisor.es"
              className="font-semibold underline"
            >
              hola@petadvisor.es
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
